import React, { FC } from "react";
import MuiSlider from "@material-ui/core/Slider";

export type Props = {
  value?: number | number[];
  onChange?: (value: number | number[]) => void;
};

const Slider: FC<Props> = (props) => {
  const handleChange = (_: any, value: number | number[]) => {
    if (!props.onChange) return;
    props.onChange(value);
  };

  const MuiProps = {
    ...props,
    component: 'span',
    onChange: handleChange
  }

  return <MuiSlider {...MuiProps} />;
};

export default Slider;
